import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';
import ChooseOption from './ChooseOption';

const displayTypeOptions = [
    {
        label: 'Radio',
        value: 'radio'
    },
    {
        label: 'Image',
        value: 'image'
    },
    {
        label: 'Pill',
        value: 'pill'
    }
];

class ChooseOneSectionItem extends Component {
    static propTypes = {
        contentValues: PropTypes.object.isRequired,
        assetLinkOptions: PropTypes.array,
        memberReference: PropTypes.string,
        isGlobalSectionItem: PropTypes.bool,
        metadataActive: PropTypes.bool,
        changeFormValue: PropTypes.func
    };

    componentDidMount() {
        const {
            // eslint-disable-next-line react/prop-types
            contentValues: { displayType = 'radio', options = [], description = '' } = {}
        } = this.props;
        if (options.length && !options[0].choice) {
            // options from props do not contain appropriate values, then reset them
            this.props.changeFormValue({ field: `${this.props.memberReference}.content`, value: { displayType } });
            if (description) {
                this.props.changeFormValue({
                    field: `${this.props.memberReference}.content.description`,
                    value: description
                });
            }
        }
    }

    render() {
        const { memberReference, contentValues, isGlobalSectionItem, metadataActive = false } = this.props;
        return (
            <div className={'chooseOneSectionItem'}>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            readOnly={isGlobalSectionItem}
                            rows={3}
                        />
                    </div>
                    <div className={'col-5 mt-4'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.displayType` : 'content.displayType'}
                        label={'Display Type'}
                        options={displayTypeOptions}
                        component={BasicSelect}
                        disabled={isGlobalSectionItem}
                        className={'col-4'}
                    />
                </div>
                <div className={'row'}>
                    <FieldArray
                        name={memberReference ? `${memberReference}.content.options` : 'content.options'}
                        contentValues={contentValues}
                        component={ChooseOption}
                        metadataActive={metadataActive}
                        disabled={isGlobalSectionItem}
                    />
                </div>
            </div>
        );
    }
}

export default ChooseOneSectionItem;
